export default __webpack_public_path__ + "static/media/CustomerCase31.5eeaca13.png";